/* eslint-disable max-len */
import { selector } from 'lib/selectors';
import { List, Set } from 'immutable';

import { jeSorterCb } from '../journal/helper';
import { rowAdapter } from './helper';
import { RECONCILED, MATCH } from 'components/Tables/Cells/ReconciliationCell/constants';
import { denormalize } from 'domain/journal/normalizer';

const reconciliation = (state) => state.reconciliation;

// search data
export const reconcileJournalSelector = selector(reconciliation, (j) => denormalize(j.searchEntry));
export const reconcileJournalEntriesSelector = selector(reconcileJournalSelector, (j) => j.entry.sort(jeSorterCb));

export const lineItemsNumbersSelector = selector(reconcileJournalSelector, (j) => j.line_items);

// selected data
export const reconcileSelectedJournalListSelector = selector(reconciliation, (j) => j.selectedEntry);

// details row
export const reconciledetailsRowSelector = selector(reconciliation, (j) => j.detailsRow);
export const reconcileRowStateSelector = selector(reconciliation, (j) => j.rowState);
export const shouldRowStateForceAutoselection = selector(reconcileRowStateSelector, (state) =>
  [MATCH, RECONCILED].includes(state),
);

// request row selectors
export const reconcileRequestRowSelector = selector(reconciliation, (j) => j.requestRow);

// column selectors
export const reconcileTransactionIdColumnSelector = selector(
  reconcileJournalSelector,
  (journal) => journal.transactionIdColumn,
);

// transactions to reconcile with
export const reconcileTransactionIdsSelector = selector(
  reconcileSelectedJournalListSelector,
  reconcileTransactionIdColumnSelector,
  (journal, column) =>
    Set(
      journal
        .map(rowAdapter)
        // $FlowFixMe flow doesnt know which cell type we are working with
        .map((V, K) => V.getIn([`${column}${K}`, 'cellSet', 'value'], '')),
    ),
);
